export default __webpack_public_path__ + "static/media/Gym-fitness-bg.cb0b3f0f.svg";